// Copyright (c) 2025 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export const MAX_DEPOSIT_INPUT_LENGTH = 20;
export const PLACEHOLDER_VALUE_DISPLAY = '--';
export const IOTA_EVM_DECIMALS = 18;
export const L1_USER_REJECTED_TX_ERROR_TEXT = 'Rejected from user';
export const L2_USER_REJECTED_TX_ERROR_TEXT = 'User rejected';
export const MINIMUM_SEND_AMOUNT = 0.1;
